(function () {
    'use strict';

    /*
        JS Usage must follow:
        jcu_js_v1.fn.functionName = function(){
           //do things here 
        }
        jcu_js_v1.vars.variableName = "I am a variable";

    */

    jcu_js_v1.fn.playPauseVideo = function () {
        var parentContainer = this.closest('.jcu-v1__ct__banner-img-vid');
        var video = parentContainer.querySelector('.jcu-v1__ct__banner-img-vid__media-video__element');
        if (video.paused) {
            video.play();
            this.classList.remove('paused');
            this.setAttribute('aria-pressed', 'true');
        } else {
            video.pause();
            this.classList.add('paused');
            this.setAttribute('aria-pressed', 'false');
        }


        // console.log('play');
    }

    jcu_js_v1.fn.initVideoPlayButtons = function () {
        jcu_js_v1.vars.videoPlayButtons = document.querySelectorAll('.jcu-v1__ct__banner-img-vid__media-video__play-pause-button');
        jcu_js_v1.vars.videoPlayButtons.forEach(element => {
            element.addEventListener('click', jcu_js_v1.fn.playPauseVideo);
        });
    }

    


    jcu_js_v1.fn.initBannerSlickSliders = function () {

        var allSlickSliders = document.querySelectorAll('.jcu-v1__ct__banner-img-vid__media-image-slider__wrapper');


        allSlickSliders.forEach(element => {
            var previousArrow = element.closest('.jcu-v1__ct__banner-img-vid__content').querySelector('.ss-button-prev');
            var nextArrow = element.closest('.jcu-v1__ct__banner-img-vid__content').querySelector('.ss-button-next');

            $(element).slick({
                prevArrow: previousArrow,
                nextArrow: nextArrow,
            });
        });

    }


    jcu_js_v1.fn.bannerVideoResizeHandler = function(){
        // console.log('load the videos');
        var zIndex = getComputedStyle(document.querySelector('body')).zIndex;
        if(zIndex > 1){
            window.removeEventListener('resize', jcu_js_v1.fn.eventThrottler);
            jcu_js_v1.fn.loadBannerVideos();

        }
        // console.log(zIndex);
    }

    jcu_js_v1.vars.eventTimeout; // Set timeout variable
    /**
     * Throttle events to only run at 15fps
     */
    jcu_js_v1.fn.eventThrottler = function () {
        // ignore resize events as long as an actualResizeHandler execution is in the queue
        if ( !jcu_js_v1.vars.eventTimeout ) {
            jcu_js_v1.vars.eventTimeout = setTimeout(function() {
                jcu_js_v1.vars.eventTimeout = null;
                jcu_js_v1.fn.bannerVideoResizeHandler();
            }, 66);
        }
    };
    
    jcu_js_v1.fn.loadBannerVideos = function(){

        var allBannerVideos = document.querySelectorAll('.jcu-v1__ct__banner-img-vid__media-video');
        allBannerVideos.forEach(element => {
            var videoElement = element.querySelector('.jcu-v1__ct__banner-img-vid__media-video__element');

            // Check to see if videoElement has any children already, to prevent duplciate source tags, also check LocalStorage for Video opt-out condition
            if(videoElement.firstElementChild === null && localStorage.getItem("video-opt-out") !== "true") {

                // Set .webm source (optional)
                var videoURL_WebM = videoElement.dataset.videourlwebm;
                if(videoURL_WebM) {
                    var source2 = document.createElement('source');        
                    source2.setAttribute('src', videoURL_WebM);
                    source2.setAttribute('type', 'video/webm');
                    videoElement.appendChild(source2);
                }

                // Set .mp4 source
                var videoURL = videoElement.dataset.videourl;
                var source1 = document.createElement('source');        
                source1.setAttribute('src', videoURL);
                source1.setAttribute('type', 'video/mp4');
                videoElement.appendChild(source1);

            }

        });


        
    }



    jcu_js_v1.fn.initBannerVideos = function(){
        //body z-index
        jcu_js_v1.fn.bannerVideoResizeHandler();

        var allBannerVideos = document.querySelectorAll('.jcu-v1__ct__banner-img-vid__media-video');


        if(allBannerVideos.length > 0){
            window.addEventListener('resize', jcu_js_v1.fn.eventThrottler);
        }

    }

    jcu_js_v1.fn.resizeBannerHeadings = function(){

        // Resize Subtext elements to the width of its H2 (Previous sibling)
        // Now running on load and DOMContentLoaded to reduce layout shift as much as possible (Normally only an issue when not cached)
        // ? Func now runs quite repeatively to ensure the widths match as much as possible to please stakeholders

        var resizeDivs = document.querySelectorAll('.jcu-v1__js-resize');
        for(var i=0;i<resizeDivs.length;i++){
            resizeDivs[i].style.width = resizeDivs[i].previousElementSibling.clientWidth + "px";
        }

        // Run Loop once on load
        document.addEventListener("DOMContentLoaded", function(){
            var resizeDivs = document.querySelectorAll('.jcu-v1__js-resize');
            for(var i=0;i<resizeDivs.length;i++){
                resizeDivs[i].style.width = resizeDivs[i].previousElementSibling.clientWidth + "px";
            }
        });

        // After DOMContentLoaded, run loop again, plus set debounced resize event listener
        window.addEventListener("load", function(){
            var resizeDivs = document.querySelectorAll('.jcu-v1__js-resize');

            // Run Once Window loaded..
            for(var i=0;i<resizeDivs.length;i++){
                resizeDivs[i].style.width = resizeDivs[i].previousElementSibling.clientWidth + "px";
            }

            // Then set Resize event on window for future updates
            if (resizeDivs.length >= 1){
                window.addEventListener("resize", jcu_js_v1.fn.debounce(function(){
                    for(var i=0;i<resizeDivs.length;i++){
                        resizeDivs[i].style.width = resizeDivs[i].previousElementSibling.clientWidth + "px";
                    }
                }, 66));
            }
        });
    }

    jcu_js_v1.fn.initBannerVideos();
    jcu_js_v1.fn.initVideoPlayButtons();
    jcu_js_v1.fn.initBannerSlickSliders();
    jcu_js_v1.fn.resizeBannerHeadings();

}());
